import { ROUTES } from '../lib/routes';
import { navigate } from '../router';
import { showModal, showToast } from '../components/toast';
import { el } from '../utils/dom';
import { submitPortalSignup } from '../api/signupPortal';

const PRODUCTS: [string, string][] = [
  ['EVOS-T', 'EVOS-T'],
  ['EVOS-STAT', 'EVOS-STAT'],
  ['EV Planner', 'EV Planner'],
  ['기타', '기타'],
];

const MEMBER_TYPES: [string, string][] = [
  ['입주민대표', '입주민대표'],
  ['시공사', '시공사'],
  ['관리사무소', '관리사무소'],
  ['기타', '기타'],
];

function textField(label: string, type: string, placeholder: string, required: boolean): HTMLElement {
  const wrap = el('div', { className: 'ev123-field' });
  const input = el('input', { className: 'ev123-input', type, placeholder, required }) as HTMLInputElement;
  wrap.append(el('label', { className: 'ev123-label', text: label }), input);
  return wrap;
}

export function renderSignupPage(root: HTMLElement): void {
  const wrap = el('div', {});

  wrap.append(
    el('div', { className: 'ev123-page-head' }, [
      el('div', { className: 'ev123-container' }, [
        el('h1', { className: 'ev123-page-head__title', text: '회원 가입 신청' }),
        el('p', {
          className: 'ev123-page-head__lead',
          text: '아래는 포털 회원 계정 신청입니다. EVOS-T/M/A 등 서비스 도입·개통은 별도의 “서비스 신청” 절차와 내부 개통이 필요하며, 회원 승인만으로는 즉시 서비스가 켜지지 않습니다.',
        }),
      ]),
    ])
  );

  const container = el('div', { className: 'ev123-container' });
  const card = el('div', { className: 'ev123-card' });

  const userId = textField('아이디', 'text', '영문·숫자 조합', true);
  const password = textField('비밀번호', 'password', '8자 이상 권장', true);
  const userName = textField('담당자 이름', 'text', '실명', true);

  const companyName = textField('회사·기관명', 'text', '사업자등록증 기준', true);
  const businessRegistrationNo = textField('사업자등록번호', 'text', '000-00-00000 또는 숫자만', true);
  const department = textField('부서', 'text', '선택', false);
  const jobTitle = textField('직함·직책', 'text', '예: 시설관리팀장', false);
  const representativeName = textField('대표자명', 'text', '선택', false);

  const phone = textField('휴대 연락처', 'tel', '010-0000-0000', true);
  const officePhone = textField('유선(사무실)', 'tel', '선택', false);
  const email = textField('이메일', 'email', 'name@example.com', true);
  const documentEmail = textField('서류·세금계산서용 이메일', 'email', '선택', false);

  const complexName = textField('단지·현장명', 'text', '아파트·단지명', true);
  const zonecode = textField('우편번호', 'text', '선택', false);
  const roadAddress = textField('도로명 주소 (현장/직장)', 'text', '주소 검색 결과', true);
  const detailAddress = textField('상세 주소', 'text', '동·호 등', false);

  const productSel = el('select', { className: 'ev123-select', required: true }) as HTMLSelectElement;
  productSel.appendChild(el('option', { value: '', text: '관심 제품 선택' }));
  for (const [v, t] of PRODUCTS) {
    productSel.appendChild(el('option', { value: v, text: t }));
  }

  const memberSel = el('select', { className: 'ev123-select', required: true }) as HTMLSelectElement;
  memberSel.appendChild(el('option', { value: '', text: '회원 유형 선택' }));
  for (const [v, t] of MEMBER_TYPES) {
    memberSel.appendChild(el('option', { value: v, text: t }));
  }

  card.append(
    el('p', {
      className: 'ev123-field-hint',
      style: 'margin:0 0 0.5rem',
      text: '회사·사업자 정보는 관리사무소·B2B 운영 확인용으로 수집됩니다.',
    }),
    userId,
    password,
    userName,
    companyName,
    businessRegistrationNo,
    department,
    jobTitle,
    representativeName,
    phone,
    officePhone,
    email,
    documentEmail,
    complexName,
    zonecode,
    roadAddress,
    detailAddress,
    el('div', { className: 'ev123-field' }, [
      el('label', { className: 'ev123-label', text: '관심 제품' }),
      productSel,
    ]),
    el('div', { className: 'ev123-field' }, [
      el('label', { className: 'ev123-label', text: '회원 유형' }),
      memberSel,
    ])
  );

  const actions = el('div', { className: 'ev123-stack', style: 'margin-top:1rem;gap:0.75rem' });
  const submit = el('button', {
    type: 'button',
    className: 'ev123-btn ev123-btn--primary ev123-btn--block',
  }) as HTMLButtonElement;
  submit.textContent = '가입 신청하기';

  const svcLink = el('p', { className: 'ev123-field-hint', style: 'text-align:center;margin:0' });
  svcLink.append(
    document.createTextNode('플랫폼 서비스 도입 문의는 '),
    (() => {
      const a = el('a', { href: ROUTES.serviceApply, 'data-nav': '' }) as HTMLAnchorElement;
      a.textContent = 'EV 서비스 도입 신청';
      return a;
    })(),
    document.createTextNode(' 메뉴를 이용해 주세요.')
  );

  const loginLink = el('p', { className: 'ev123-field-hint', style: 'text-align:center;margin:0' });
  loginLink.append(
    document.createTextNode('이미 신청이 승인되셨나요? '),
    (() => {
      const a = el('a', { href: ROUTES.login, 'data-nav': '' }) as HTMLAnchorElement;
      a.textContent = '로그인';
      return a;
    })()
  );

  submit.addEventListener('click', async () => {
    const q = (field: HTMLElement) => field.querySelector('input') as HTMLInputElement | null;

    const uid = q(userId)?.value?.trim() ?? '';
    const pwd = q(password)?.value ?? '';
    const nm = q(userName)?.value?.trim() ?? '';
    const cn = q(companyName)?.value?.trim() ?? '';
    const br = q(businessRegistrationNo)?.value?.trim() ?? '';
    const dept = q(department)?.value?.trim() ?? '';
    const jt = q(jobTitle)?.value?.trim() ?? '';
    const rep = q(representativeName)?.value?.trim() ?? '';
    const ph = q(phone)?.value?.trim() ?? '';
    const op = q(officePhone)?.value?.trim() ?? '';
    const em = q(email)?.value?.trim() ?? '';
    const docEm = q(documentEmail)?.value?.trim() ?? '';
    const cx = q(complexName)?.value?.trim() ?? '';
    const zc = q(zonecode)?.value?.trim() ?? '';
    const road = q(roadAddress)?.value?.trim() ?? '';
    const det = q(detailAddress)?.value?.trim() ?? '';

    if (!uid) {
      showToast('아이디를 입력해 주세요.');
      return;
    }
    if (pwd.length < 8) {
      showToast('비밀번호는 8자 이상 입력해 주세요.');
      return;
    }
    if (!nm || !cn || !br || !ph || !em || !cx || !road) {
      showToast('필수 항목(회사명·사업자번호·연락처·이메일·현장·주소 등)을 모두 입력해 주세요.');
      return;
    }
    if (!productSel.value || !memberSel.value) {
      showToast('관심 제품과 회원 유형을 선택해 주세요.');
      return;
    }

    submit.disabled = true;
    const prev = submit.textContent;
    submit.textContent = '접수 중…';
    try {
      await submitPortalSignup({
        userId: uid,
        password: pwd,
        userName: nm,
        position: jt || null,
        companyName: cn,
        businessRegistrationNo: br,
        department: dept || null,
        jobTitle: jt || null,
        representativeName: rep || null,
        officePhone: op || null,
        documentEmail: docEm || null,
        phone: ph,
        email: em,
        complexName: cx,
        zonecode: zc || null,
        roadAddress: road,
        detailAddress: det || null,
        product: productSel.value,
        memberType: memberSel.value,
      });
      showModal({
        title: '신청 완료',
        body: '포털 회원 가입 신청이 접수되었습니다. 관리자 승인 후 로그인하실 수 있습니다. EV 플랫폼 서비스 이용은 별도 서비스 신청·개통이 완료되어야 합니다.',
        confirmLabel: '확인',
        onClose: () => navigate(ROUTES.homePublic),
      });
    } catch (e) {
      showToast(e instanceof Error ? e.message : '신청에 실패했습니다.');
    } finally {
      submit.disabled = false;
      submit.textContent = prev ?? '가입 신청하기';
    }
  });

  actions.append(submit, svcLink, loginLink);
  card.appendChild(actions);
  container.appendChild(card);
  wrap.appendChild(container);
  root.appendChild(wrap);
}
